import { useEffect, useState } from 'react';
import { Section } from '@ui-kit/Section';
import { Menu } from './Menu';
import { useWindowSizing } from '@app/hooks/useSizeWindow';
import classNames from 'classnames';

import styles from './HeaderSticky.module.scss';

export const HeaderStiky = ({ shortHeader }: { shortHeader?: boolean }): JSX.Element => {
  const mobileWindow = useWindowSizing(990);
  const [show, setShow] = useState<boolean>(false);

  useEffect(() => {
    if (!mobileWindow) {
      const handler = () => {
        if (scrollY > 295) {
          setShow(true);
        } else if (scrollY < 295) {
          setShow(false);
        }
      };
      window.addEventListener('scroll', handler);
      return () => window.removeEventListener('scroll', handler);
    }
  }, [mobileWindow]);

  return (
    <div className={classNames(styles.Wrapper, show && styles.Show, shortHeader && styles.FixedBlock)}>
      <Section className={styles.Container}>
        <Menu />
      </Section>
    </div>
  );
};
